import { useEffect, useRef, useState } from "react";

// Count-up number that animates once it scrolls into view.
export default function AnimatedCounter({ to = 100, duration = 2000, suffix = "", prefix = "" }) {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const start = () => {
      if (started.current) return;
      started.current = true;
      const t0 = performance.now();
      const tick = (now) => {
        const p = Math.min((now - t0) / duration, 1);
        // easeOutExpo for a luxe deceleration
        const eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
        setValue(Math.round(eased * to));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && start()),
      { threshold: 0.4 }
    );
    io.observe(el);
    const fallback = setTimeout(start, 1200);
    return () => {
      io.disconnect();
      clearTimeout(fallback);
    };
  }, [to, duration]);

  return (
    <span ref={ref} data-testid="animated-counter">
      {prefix}
      {value.toLocaleString()}
      {suffix}
    </span>
  );
}
